import React from "react";
import IssuePragatiLogo from "./../../assets/PRAGATI.svg";

function IssuePragatiReview({ className, isPragati, isAgendaDetail = false }) {
  return isPragati ? (
    <div className={isAgendaDetail ? className : className}>
      <img alt="issuePragati" src={IssuePragatiLogo} />
    </div>
  ) : null;
}

export default IssuePragatiReview;
